<script setup>
import { store } from '../store'
</script>

<template>
  <div class="about-page">
    <section class="about-hero-new">
      <div class="about-hero-copy">
        <span class="signal"><i></i> 关于尔数创研</span>
        <h1>认真理解需求，<br>把复杂的事讲清楚</h1>
        <p>{{ store.site.aboutIntro || '我们是一支关注交付质量与长期维护的产品技术团队。' }}</p>
        <div class="about-actions"><RouterLink class="button" to="/projects">查看项目</RouterLink><RouterLink class="text-link" to="/deploy">了解部署服务 <b>→</b></RouterLink></div>
      </div>
      <div class="about-identity" aria-label="尔数创研团队标识">
        <div class="identity-orbit orbit-one"></div><div class="identity-orbit orbit-two"></div>
        <div class="identity-core"><b>尔</b><span>ERSHU STUDIO</span></div>
        <span class="identity-note note-top">清楚沟通</span><span class="identity-note note-bottom">可靠交付</span>
      </div>
    </section>

    <section class="about-proof">
      <div><strong>需求先对齐</strong><span>范围、目标和风险先说清楚</span></div>
      <div><strong>过程可追踪</strong><span>每个关键节点都有明确状态</span></div>
      <div><strong>交付可维护</strong><span>让项目上线后仍然容易接手</span></div>
    </section>

    <section class="about-narrative">
      <div class="narrative-heading"><span>我们为什么这样做</span><h2>好交付，从来不只是一份代码</h2></div>
      <div class="narrative-body"><p>很多项目的问题并不只发生在代码里。需求没有对齐、环境没有记录、验收标准不清楚，都会让最后一步变得困难。</p><p>因此，我们把服务拆成可确认的节点。你能知道现在做到哪一步、下一步需要什么，以及最终会收到哪些内容。</p><div class="about-principles"><span>不夸大能力</span><span>不隐藏关键状态</span><span>不模糊资料边界</span></div></div>
    </section>

    <section class="about-method">
      <div class="method-statement"><span>我们的共识</span><blockquote>交付不是项目结束，<br>而是用户真正开始使用。</blockquote></div>
      <ol>
        <li><b>01</b><div><h3>先判断，再承诺</h3><p>先确认范围、风险与依赖，再给出时间和方案。</p></div></li>
        <li><b>02</b><div><h3>过程始终留痕</h3><p>关键配置、操作和验收结果都有据可查。</p></div></li>
        <li><b>03</b><div><h3>尊重已有成果</h3><p>先理解现有代码与业务，不做无意义的推翻重来。</p></div></li>
      </ol>
    </section>

    <section class="about-cta"><div><h2>有一个想法，想先聊清楚？</h2><p>告诉我们你要解决的问题，我们会先判断范围和可行性。</p></div><RouterLink class="button" to="/projects">提交项目需求</RouterLink></section>
  </div>
</template>
